<div *ngIf='componentReady && messages && messages.length > 0' class='mb-3'>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        Message
      </mat-panel-title>
      <mat-panel-description>Click to exand the message</mat-panel-description>
    </mat-expansion-panel-header>
    <app-message-viewer
      *ngFor='let message of messages'
      [message]='message'
      [sessionData]='sessionData'></app-message-viewer>
  </mat-expansion-panel>
</div>
<div [formGroup]='formGroup' class='FormContainer'>
  <div class='row'>
    <div class='col-6 offset-3'>
      <mat-label><b>Group</b></mat-label>
      <app-select
        (selection)='onGroupSelection($event)'
        *ngIf='contactGroupsItems.length'
        [items]='contactGroupsItems'
        formControlName='group_id'
        label='Select Existing group'
        required></app-select>
      <div
        *ngIf='group_id.touched && group_id.dirty && group_id.errors'
        class='alert alert-danger'>
        <p *ngIf='group_id.errors?.required'>Group selection is required!</p>
      </div>
    </div>
  </div>
  <div *ngIf='showGroupControl' class='row mt-3'>
    <div class='col-md-6 offset-3'>
      <mat-label><b>Group name</b></mat-label>
      <app-text-field
        (focusout)='checkNewGroup($event.target.value)'
        formControlName='group_name'
        placeholder='Group name'></app-text-field>
      <div
        *ngIf='group_name.touched && !group_name.valid && group_name.errors'
        class='alert alert-danger'>
        <p *ngIf='group_name.errors?.required'>Group name is required!</p>
      </div>
    </div>
  </div>
  <div class='row mt-3'>
    <div class='col-md-6 offset-3'>
      <mat-label><b>Email</b></mat-label>
      <app-text-field
        [disabled]='true'
        formControlName='email'
        placeholder='Email'></app-text-field>
    </div>
  </div>
  <div class='row mt-3'>
    <div class='col col-md-6 offset-3'>
      <mat-label><b>First name</b></mat-label>
      <app-text-field
        formControlName='firstname'
        placeholder='First name'></app-text-field>
    </div>
  </div>
  <div class='row mt-3'>
    <div class='col col-md-6 offset-3'>
      <mat-label><b>Last name</b></mat-label>
      <app-text-field
        formControlName='lastname'
        placeholder='Last name'></app-text-field>
    </div>
  </div>
  <div class='row mt-3'>
    <div class='col col-md-6 offset-3'>
      <mat-label><b>Company</b></mat-label>
      <app-text-field
        formControlName='company'
        placeholder='Company'></app-text-field>
    </div>
  </div>
  <div class='row mt-3'>
    <div class='col col-md-6 offset-3'>
      <mat-label><b>Title</b></mat-label>
      <app-text-field
        formControlName='title'
        placeholder='Title'></app-text-field>
    </div>
  </div>
  <div class='row mt-3'>
    <div class='col col-md-6 offset-3'>
      <mat-label><b>Phone number</b></mat-label>
      <app-text-field
        formControlName='phone_number'
        placeholder='Phone'></app-text-field>
    </div>
  </div>
</div>
